import {
  add2suhfggl4zvkk as add,
  subtract2orl8z9upxd9l as subtract,
  fromInt2ii0rejb1w62w as fromInt,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { Buffergs925ekssbch as Buffer } from '../../../../../kotlinx-io-kotlinx-io-core/kotlinx/io/Buffer.mjs';
import {
  awaitContent$default2x8iq90jfihc1 as awaitContent$default,
  ByteReadChannel2wzou76jce72d as ByteReadChannel,
} from './ByteReadChannel.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function transferFromDelegate($this) {
  updateConsumed($this);
  var appended = $this.p4l_1.z4g($this.o4l_1.l4j());
  $this.q4l_1 = add($this.q4l_1, appended);
}
function updateConsumed($this) {
  $this.r4l_1 = add($this.r4l_1, subtract($this.q4l_1, $this.p4l_1.q2()));
  $this.q4l_1 = $this.p4l_1.q2();
}
var CountedByteReadChannelClass;
function CountedByteReadChannel() {
  if (CountedByteReadChannelClass === VOID) {
    class $ {
      constructor(delegate) {
        this.o4l_1 = delegate;
        this.p4l_1 = new (Buffer())();
        this.q4l_1 = 0n;
        this.r4l_1 = 0n;
      }
      s4l() {
        updateConsumed(this);
        return this.r4l_1;
      }
      y4j() {
        return this.o4l_1.y4j();
      }
      d4k() {
        return this.p4l_1.v3v() && this.o4l_1.d4k();
      }
      l4j() {
        transferFromDelegate(this);
        return this.p4l_1;
      }
      *e4k(min, $completion) {
        if (this.l4j().q2() >= fromInt(min)) {
          return true;
        }
        if (yield* this.o4l_1.e4k(min, $completion)) {
          transferFromDelegate(this);
          return true;
        }
        return false;
      }
      o4k(cause) {
        this.o4l_1.o4k(cause);
        this.p4l_1.l6();
      }
    }
    protoOf($).k4k = awaitContent$default;
    initMetadataForClass($, 'CountedByteReadChannel', VOID, VOID, [ByteReadChannel()], [1]);
    CountedByteReadChannelClass = $;
  }
  return CountedByteReadChannelClass;
}
function counted(_this__u8e3s4) {
  return new (CountedByteReadChannel())(_this__u8e3s4);
}
//region block: exports
export {
  counted as counted3iniv3aql3f9n,
};
//endregion

//# sourceMappingURL=CountedByteReadChannel.mjs.map
